// Studio Laetitia — candle illustration engine (fallback art when a product has no photo).
window.CANDLE_MOTIFS = {
        heart: {
          d:'M 0 6.5 C -8 1, -8.5 -5, -4 -6.5 C -1.5 -7, 0 -5, 0 -3 C 0 -5, 1.5 -7, 4 -6.5 C 8.5 -5, 8 1, 0 6.5 Z',
          fill:'#C8102E', stroke:'#9A0B22', positions:[55,105,155]
        },
        tree: {
          d:'M 0 -10 L 4 -4 L 1.8 -4 L 6 1 L 3 1 L 8 6.5 L -8 6.5 L -3 1 L -6 1 L -1.8 -4 L -4 -4 Z',
          fill:'#2C5F3A', stroke:'#1F4529', positions:[55,105,155]
        },
        star: {
          d:'M 0 -8 L 2.3 -2.5 L 8 -2.5 L 3.5 1 L 5 6 L 0 2.8 L -5 6 L -3.5 1 L -8 -2.5 L -2.3 -2.5 Z',
          fill:'#FFC72C', stroke:'#1E1A16', positions:[45,90,135,180]
        },
        starSmall: {
          d:'M 0 -4.96 L 1.43 -1.55 L 4.96 -1.55 L 2.17 0.62 L 3.1 3.72 L 0 1.74 L -3.1 3.72 L -2.17 0.62 L -4.96 -1.55 L -1.43 -1.55 Z',
          fill:'#D4A648', stroke:'#9C7A22', positions:[45,80,115,150,185]
        },
        heartSmall: {
          d:'M 0 4.55 C -5.6 0.7, -5.95 -3.5, -2.8 -4.55 C -1.05 -4.9, 0 -3.5, 0 -2.1 C 0 -3.5, 1.05 -4.9, 2.8 -4.55 C 5.95 -3.5, 5.6 0.7, 0 4.55 Z',
          fill:'#C8102E', stroke:'#9A0B22', positions:[45,80,115,150,185]
        },
        kiss: {
          d:'M 0 6.5 C -8 1, -8.5 -5, -4 -6.5 C -1.5 -7, 0 -5, 0 -3 C 0 -5, 1.5 -7, 4 -6.5 C 8.5 -5, 8 1, 0 6.5 Z',
          fill:'#FFC72C', stroke:'#C8102E', positions:[55,105,155]
        },
        angel: {
          d:'M 0 -7 A 3 3 0 1 1 0 -1 Q -5 -2 -6 4 Q 0 8 6 4 Q 5 -2 0 -1 M -8 -6 Q -4 -8 0 -6 Q 4 -8 8 -6',
          fill:'#FFFDF7', stroke:'#1E1A16', positions:[55,105,155]
        },
        bell: {
          d:'M 0 -7 Q -6 -7 -6 2 L 6 2 Q 6 -7 0 -7 Z M -2 5 Q 0 7 2 5 M 0 6 L 0 7.5',
          fill:'#B4885A', stroke:'#1E1A16', positions:[55,105,155]
        },
        pumpkin: {
          d:'M 0 -6 Q -7 -6 -7 0 Q -7 6 0 6 Q 7 6 7 0 Q 7 -6 0 -6 Z M -3.5 -5.5 Q -3.5 0 -3.5 5.5 M 0 -6 L 0 6 M 3.5 -5.5 Q 3.5 0 3.5 5.5 M 0 -6 L -1 -8 L 1 -8 L 0 -6',
          fill:'#E07A2E', stroke:'#1E1A16', positions:[55,105,155]
        },
        ghost: {
          d:'M -5 -6 Q -5 -8 0 -8 Q 5 -8 5 -6 L 5 4 L 3 6 L 1.5 4 L 0 6 L -1.5 4 L -3 6 L -5 4 Z',
          fill:'#FFFDF7', stroke:'#1E1A16', positions:[55,105,155]
        },
        bat: {
          d:'M 0 0 L -2 -3 Q -7 -5 -10 -2 Q -8 -1 -8 1 Q -6 0 -3 1 L -2 3 L 0 2 L 2 3 L 3 1 Q 6 0 8 1 Q 8 -1 10 -2 Q 7 -5 2 -3 Z',
          fill:'#1E1A16', stroke:'#1E1A16', positions:[55,105,155]
        },
        champagne: {
          d:'M -3.5 -8 L 3.5 -8 L 3 -2 Q 3 2 0 2 Q -3 2 -3 -2 Z M 0 2 L 0 7 M -2.5 7.5 L 2.5 7.5 M -2.5 -8 L -1 -10 L 1 -10 L 2.5 -8',
          fill:'#FFC72C', stroke:'#1E1A16', positions:[55,105,155]
        },
        firework: {
          d:'M 0 -8 L 0 -3 M 0 3 L 0 8 M -8 0 L -3 0 M 3 0 L 8 0 M -5.5 -5.5 L -2 -2 M 2 2 L 5.5 5.5 M 5.5 -5.5 L 2 -2 M -2 2 L -5.5 5.5 M 0 0 L .1 .1',
          fill:'none', stroke:'#C8102E', positions:[50,95,140,185]
        },
        confetti: {
          d:'M -6 -4 L -3 -6 L -2 -3 Z M 4 -5 L 7 -3 L 5 0 Z M -5 3 L -2 4 L -4 7 Z M 3 4 L 6 5 L 4 8 Z M 0 -2 L 1 0 L -1 1 Z',
          fill:'#FF6FA8', stroke:'#C8458A', positions:[55,105,155]
        },
        cloud: {
          d:'M -7 3.5 Q -9 3.5 -9 1 Q -9 -1.5 -6 -1.5 Q -6 -5.5 -2 -5 Q -0.5 -7.2 2 -5.5 Q 4.6 -6 5 -2.5 Q 8.5 -3 8.5 0.5 Q 8.5 3.5 6 3.5 Z',
          fill:'#9DBFDC', stroke:'#6E97BD', positions:[55,105,155]
        },
        bow: {
          d:'M 0 0 Q -9 -6 -8.5 0 Q -9 6 0 0 Z M 0 0 Q 9 -6 8.5 0 Q 9 6 0 0 Z M -2 -2.2 Q 0 -3 2 -2.2 L 2 2.2 Q 0 3 -2 2.2 Z',
          fill:'#9DBFDC', stroke:'#6E97BD', positions:[55,105,155]
        },
        flower: {
          d:'M -2.6 -4.5 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M 1.7 -1.4 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M 0 3.6 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M -5.2 3.6 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M -6.9 -1.4 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M -1.9 0 a 1.9 1.9 0 1 0 3.8 0 a 1.9 1.9 0 1 0 -3.8 0',
          fill:'#EFA9C0', stroke:'#CC819B', positions:[55,105,155]
        },
        bunny: {
          d:'M 0 8 C 4 8 4.6 4.5 4 2 C 3.6 0.3 2.6 -0.6 2 -1.4 C 2.6 -2.2 2.4 -3 2.2 -3.6 C 2.8 -5.5 2.6 -9 1.4 -9 C 0.4 -9 0.5 -6 0.6 -4 C 0.3 -4.1 -0.3 -4.1 -0.6 -4 C -0.5 -6 -0.4 -9 -1.4 -9 C -2.6 -9 -2.8 -5.5 -2.2 -3.6 C -2.4 -3 -2.6 -2.2 -2 -1.4 C -2.6 -0.6 -3.6 0.3 -4 2 C -4.6 4.5 -4 8 0 8 Z',
          fill:'#8A6240', stroke:'#5E4128', positions:[55,105,155]
        },
        flag: {
          positions:[55,105,155],
          parts:[
            {d:'M -8 -5.4 L 8 -5.4 L 8 -1.8 L -8 -1.8 Z', fill:'#161616', stroke:'none'},
            {d:'M -8 -1.8 L 8 -1.8 L 8 1.8 L -8 1.8 Z', fill:'#D81E2C', stroke:'none'},
            {d:'M -8 1.8 L 8 1.8 L 8 5.4 L -8 5.4 Z', fill:'#FBCB00', stroke:'none'},
            {d:'M -8 -5.4 L 8 -5.4 L 8 5.4 L -8 5.4 Z', fill:'none', stroke:'#1E1A16', sw:'.8'}
          ]
        },
        tvtower: {
          d:'M -0.32 -4 L 0.32 -4 L 0.13 -11 L -0.13 -11 Z M -2.3 -4 a 2.3 2.3 0 1 0 4.6 0 a 2.3 2.3 0 1 0 -4.6 0 M -0.7 -1.9 L 0.7 -1.9 L 1.2 8 L -1.2 8 Z',
          fill:'#9AA0A6', stroke:'#5F6368', positions:[55,105,155]
        },
        butterfly: {
          d:'M -0.7 0 a 0.7 5 0 1 0 1.4 0 a 0.7 5 0 1 0 -1.4 0 M -7.2 -3 a 3.2 3.2 0 1 0 6.4 0 a 3.2 3.2 0 1 0 -6.4 0 M 0.8 -3 a 3.2 3.2 0 1 0 6.4 0 a 3.2 3.2 0 1 0 -6.4 0 M -5.4 3.5 a 2.4 2.4 0 1 0 4.8 0 a 2.4 2.4 0 1 0 -4.8 0 M 0.6 3.5 a 2.4 2.4 0 1 0 4.8 0 a 2.4 2.4 0 1 0 -4.8 0 M 0 -5 Q -2 -7.5 -3 -7.5 M 0 -5 Q 2 -7.5 3 -7.5',
          fill:'#E8A23D', stroke:'#B97A20', positions:[55,105,155]
        },
        brezel: {
          positions:[55,105,155],
          parts:[{
            d:'M -7 -1 C -7 -6 -2 -7.5 0 -4 C 2 -7.5 7 -6 7 -1 C 7 4.5 3.5 7 0 7 C -3.5 7 -7 4.5 -7 -1 Z M -4.6 -1.5 a 1.9 1.9 0 1 0 3.8 0 a 1.9 1.9 0 1 0 -3.8 0 M 0.8 -1.5 a 1.9 1.9 0 1 0 3.8 0 a 1.9 1.9 0 1 0 -3.8 0 M -2.3 2.8 a 2.3 2.3 0 1 0 4.6 0 a 2.3 2.3 0 1 0 -4.6 0',
            fill:'#C88A3C', stroke:'#9A6322', fr:'evenodd', sw:'.8'
          }]
        },
        bear: {
          d:'M -3.5 -8.4 a 1.5 1.5 0 1 0 3 0 a 1.5 1.5 0 1 0 -3 0 M 0.5 -8.4 a 1.5 1.5 0 1 0 3 0 a 1.5 1.5 0 1 0 -3 0 M -3.3 -6 a 3.3 3.3 0 1 0 6.6 0 a 3.3 3.3 0 1 0 -6.6 0 M -3.4 -3 C -4.3 -2.4 -4.5 4.2 -3.4 6.3 C -2.8 7.6 2.8 7.6 3.4 6.3 C 4.5 4.2 4.3 -2.4 3.4 -3 C 1.5 -4 -1.5 -4 -3.4 -3 Z M -4.7 -1.4 C -6.1 -0.7 -6.3 2.1 -5.2 3.1 C -4.6 2.2 -4 1 -3.6 -0.3 Z M 4.7 -1.4 C 6.1 -0.7 6.3 2.1 5.2 3.1 C 4.6 2.2 4 1 3.6 -0.3 Z',
          fill:'#2A2A2A', stroke:'#111111', positions:[55,105,155]
        },
        dachshund: {
          d:'M -6.2 -1.6 L 4.6 -1.6 Q 5.4 -1.6 5.4 -0.8 L 5.4 0.8 Q 5.4 1.6 4.6 1.6 L -6.2 1.6 Q -7 1.6 -7 0.8 L -7 -0.8 Q -7 -1.6 -6.2 -1.6 Z M 4.8 -1.8 C 4.8 -3.8 6.2 -4.6 7.2 -4 C 7.8 -3.6 8 -2.8 7.8 -2.2 C 8.8 -2.2 8.9 -1.1 8 -0.9 L 7.2 -0.8 C 6.8 -0.7 6.4 -0.9 6.2 -1.2 C 5.4 -1 4.8 -1.2 4.8 -1.8 Z M 4.2 -2.6 C 3.2 -2.4 3 -0.2 3.8 1.2 C 4.2 1.9 5.1 1.7 5.3 0.8 C 5.6 -0.6 5.2 -2.4 4.2 -2.6 Z M -6.4 -1 C -7.6 -1.8 -8.2 -3.4 -7.2 -4 C -6.6 -3.2 -6.4 -2.2 -6 -1.4 Z M -5.6 0.8 L -4.6 0.8 L -4.6 4.6 Q -4.6 5.1 -5.1 5.1 Q -5.6 5.1 -5.6 4.6 Z M -3.3 0.8 L -2.3 0.8 L -2.3 4.6 Q -2.3 5.1 -2.8 5.1 Q -3.3 5.1 -3.3 4.6 Z M 2.6 0.8 L 3.6 0.8 L 3.6 4.6 Q 3.6 5.1 3.1 5.1 Q 2.6 5.1 2.6 4.6 Z M 3.9 0.8 L 4.9 0.8 L 4.9 4.6 Q 4.9 5.1 4.4 5.1 Q 3.9 5.1 3.9 4.6 Z',
          fill:'#9A5B2D', stroke:'#6E3F1C', positions:[55,105,155]
        },
        paw: {
          d:'M -3 2.5 a 3 2.4 0 1 0 6 0 a 3 2.4 0 1 0 -6 0 M -4.8 -1 a 1.2 1.4 0 1 0 2.4 0 a 1.2 1.4 0 1 0 -2.4 0 M -2.4 -2.6 a 1.2 1.4 0 1 0 2.4 0 a 1.2 1.4 0 1 0 -2.4 0 M 0 -2.6 a 1.2 1.4 0 1 0 2.4 0 a 1.2 1.4 0 1 0 -2.4 0 M 2.4 -1 a 1.2 1.4 0 1 0 2.4 0 a 1.2 1.4 0 1 0 -2.4 0',
          fill:'#A86A38', stroke:'#7C4C24', positions:[55,105,155]
        },
        bone: {
          d:'M -5.4 -1.6 L 5.4 -1.6 L 5.4 1.6 L -5.4 1.6 Z M -7.1 -1.7 a 1.7 1.7 0 1 0 3.4 0 a 1.7 1.7 0 1 0 -3.4 0 M -7.1 1.7 a 1.7 1.7 0 1 0 3.4 0 a 1.7 1.7 0 1 0 -3.4 0 M 3.7 -1.7 a 1.7 1.7 0 1 0 3.4 0 a 1.7 1.7 0 1 0 -3.4 0 M 3.7 1.7 a 1.7 1.7 0 1 0 3.4 0 a 1.7 1.7 0 1 0 -3.4 0',
          fill:'#E0CDA0', stroke:'#B49A5E', positions:[55,105,155]
        },
        sun: {
          d:'M -3 0 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0 M 0 -8 L 1.2 -4.8 L -1.2 -4.8 Z M 0 8 L 1.2 4.8 L -1.2 4.8 Z M -8 0 L -4.8 1.2 L -4.8 -1.2 Z M 8 0 L 4.8 1.2 L 4.8 -1.2 Z M -5.7 -5.7 L -3 -4 L -4 -3 Z M 5.7 -5.7 L 4 -3 L 3 -4 Z M 5.7 5.7 L 3 4 L 4 3 Z M -5.7 5.7 L -4 3 L -3 4 Z',
          fill:'#F0B429', stroke:'#C98A0E', positions:[55,105,155]
        },
        wave: {
          d:'M -8 -1.4 Q -6 -4.4 -4 -1.4 Q -2 1.6 0 -1.4 Q 2 -4.4 4 -1.4 Q 6 1.6 8 -1.4 L 8 0.8 Q 6 3.8 4 0.8 Q 2 -2.2 0 0.8 Q -2 3.8 -4 0.8 Q -6 -2.2 -8 0.8 Z',
          fill:'#3E8FB0', stroke:'#2C6A86', positions:[50,100,150]
        },
        cherry: {
          d:'M -3.6 0.6 a 2.6 2.6 0 1 0 5.2 0 a 2.6 2.6 0 1 0 -5.2 0 M 0.4 0.2 a 2.4 2.4 0 1 0 4.8 0 a 2.4 2.4 0 1 0 -4.8 0 M -0.6 -7 Q -3 -3.5 -1.4 0.4 L -2.4 0.6 Q -4 -3.5 -1.4 -7.2 Z M -0.6 -7 Q 2.4 -3.8 2.4 -0.2 L 3.4 -0.4 Q 3.2 -4 0.4 -7.2 Z M -0.6 -7 Q 2.6 -9.4 5.6 -7 Q 2.6 -5.4 -0.6 -7 Z',
          fill:'#C8102E', stroke:'#9A0B22', positions:[55,105,155]
        },
        shell: {
          positions:[55,105,155],
          parts:[
            {d:'M 0 6 C -2 6 -7 0 -6.5 -2.5 L -5.2 -1.2 L -4.8 -3.4 L -3 -1.6 L -2.4 -3.9 L 0 -2.1 L 2.4 -3.9 L 3 -1.6 L 4.8 -3.4 L 5.2 -1.2 L 6.5 -2.5 C 7 0 2 6 0 6 Z', fill:'#F2B8B8', stroke:'#CC8585'},
            {d:'M 0 5.5 L -3.8 -2.4 M 0 5.5 L 0 -2.1 M 0 5.5 L 3.8 -2.4 M 0 5.5 L -2 -1.9 M 0 5.5 L 2 -1.9', fill:'none', stroke:'#CC8585', sw:'.6'}
          ]
        },
        aries: {
          parts:[{d:'M -6 2.5 L -2 0 L 2 -2 L 6 -3.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,2.5],[-2,0],[2,-2],[6,-3.5]], positions:[55,105,155]
        },
        taurus: {
          parts:[{d:'M -6 -3 L 0 2 L 6 -3', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-3],[-3,-0.5],[0,2],[3,-0.5],[6,-3]], positions:[55,105,155]
        },
        gemini: {
          parts:[{d:'M -3.5 -5 L -3.5 5 M 3.5 -5 L 3.5 5 M -3.5 -5 L 3.5 -5 M -3.5 5 L 3.5 5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-3.5,-5],[-3.5,5],[3.5,-5],[3.5,5]], positions:[55,105,155]
        },
        cancer: {
          parts:[{d:'M 0 -5 L 0 0 M 0 0 L -4.5 4 M 0 0 L 4.5 4', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[0,-5],[0,0],[-4.5,4],[4.5,4]], positions:[55,105,155]
        },
        leo: {
          parts:[{d:'M -6 -1.5 L -3.5 -3 L -1 -1 L -1.5 2.5 M -1 -1 L 3 0.5 L 6 3 L -1.5 2.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-1.5],[-3.5,-3],[-1,-1],[3,0.5],[6,3],[-1.5,2.5]], positions:[55,105,155]
        },
        virgo: {
          parts:[{d:'M -6 -3 L -3.5 -1 L -0.5 -2 L 2 1 L 3.5 4 M 2 1 L 6 -1', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-3],[-3.5,-1],[-0.5,-2],[2,1],[3.5,4],[6,-1]], positions:[55,105,155]
        },
        libra: {
          parts:[{d:'M -6 2.5 L -3 -0.5 L 0 -1.5 L 3 -0.5 L 6 2.5 M 0 -1.5 L 0 -5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,2.5],[-3,-0.5],[0,-1.5],[3,-0.5],[6,2.5],[0,-5]], positions:[55,105,155]
        },
        scorpio: {
          parts:[{d:'M -6 -4 L -4 -2 L -1 -1 L 2 0 L 4 3 L 6 1.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-4],[-4,-2],[-1,-1],[2,0],[4,3],[6,1.5]], positions:[55,105,155]
        },
        sagittarius: {
          parts:[{d:'M -6 4 L 4 -4 M 4 -4 L -0.5 -4 M 4 -4 L 4 0.5 M -3 0.5 L 1 -3.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,4],[4,-4],[0,-4],[4,0],[-1,-1.5]], positions:[55,105,155]
        },
        capricorn: {
          parts:[{d:'M -6 -3 L -3 1 L 0 -1.5 L 2.5 2 L 4.5 3 C 6.5 3 6.5 -0.5 3.5 -0.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-3],[-3,1],[0,-1.5],[2.5,2],[4.5,3]], positions:[55,105,155]
        },
        aquarius: {
          parts:[{d:'M -6 -2 Q -4.5 -4 -3 -2 Q -1.5 0 0 -2 Q 1.5 -4 3 -2 Q 4.5 0 6 -2 M -6 2.5 Q -4.5 0.5 -3 2.5 Q -1.5 4.5 0 2.5 Q 1.5 0.5 3 2.5 Q 4.5 4.5 6 2.5', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-6,-2],[6,-2],[-6,2.5],[6,2.5]], positions:[55,105,155]
        },
        pisces: {
          parts:[{d:'M -5 -5 Q -8 0 -5 5 M 5 -5 Q 8 0 5 5 M -6.5 0 L 6.5 0', fill:'none', stroke:'#C98A0E', sw:'.7'}],
          dots:[[-5,-5],[-5,5],[5,-5],[5,5]], positions:[55,105,155]
        }
      };

window.SL_COLOURS = {
  'Gold':         { fill:'#D4A648', stroke:'#9C7A22' },
  'Silver':       { fill:'#C9CDD1', stroke:'#7E8389' },
  'Bronze':       { fill:'#B4885A', stroke:'#7A5A36' },
  'Forest Green': { fill:'#1A3823', stroke:'#0F2516' },
  'Cherry Red':   { fill:'#C8102E', stroke:'#8E0A20' },
  'Dusty Pink':   { fill:'#E0A9AE', stroke:'#B47C82' },
  'Burgundy':     { fill:'#6E1220', stroke:'#4A0B15' }
};

// handle -> motif key, used when a product has no custom.motif metafield
window.SL_MOTIF_BY_HANDLE = {
  'north-star':'star', 'star-fall':'starSmall', 'winter-tree':'tree',
  'snow-angel':'angel', 'frost-heart':'heart', 'little-frost-heart':'heartSmall', 'heart-taper':'heart',
  'winterstar':'star', 'christmastree':'tree'
};

window.SL_motifFor = function(el){
  return el.dataset.candleMotif || window.SL_MOTIF_BY_HANDLE[el.dataset.candleHandle] || 'star';
};

window.SL_mountCandle = function(el, motifKey, colourName){
  const tpl = document.getElementById('candle-template');
  if(!tpl) return;
  const ns = 'http://www.w3.org/2000/svg';
  const o = window.SL_COLOURS[colourName] || null;
  el.innerHTML = '';
  const svg = tpl.content.cloneNode(true).querySelector('svg').cloneNode(true);
  svg.setAttribute('preserveAspectRatio','xMidYMid meet');
  svg.style.width='auto'; svg.style.height='100%'; svg.style.display='block';
  const g0 = svg.querySelector('.stickers');
  const m = window.CANDLE_MOTIFS[motifKey];
  if(m && g0){
    const parts = m.parts || [{d:m.d, fill:m.fill, stroke:m.stroke, sw:m.sw}];
    m.positions.forEach(function(y){
      const g = document.createElementNS(ns,'g');
      g.setAttribute('transform','translate(0 '+y+')');
      parts.forEach(function(part){
        const p = document.createElementNS(ns,'path');
        p.setAttribute('d', part.d);
        p.setAttribute('fill', part.fill === 'none' ? 'none' : (o ? o.fill : part.fill));
        p.setAttribute('stroke', o ? (part.fill === 'none' ? o.fill : o.stroke) : part.stroke);
        p.setAttribute('stroke-width', part.sw || '.7');
        p.setAttribute('stroke-linejoin','round');
        p.setAttribute('stroke-linecap','round');
        if(part.fr) p.setAttribute('fill-rule', part.fr);
        g.appendChild(p);
      });
      if(m.dots){
        m.dots.forEach(function(d){
          const c = document.createElementNS(ns,'circle');
          c.setAttribute('cx',d[0]); c.setAttribute('cy',d[1]); c.setAttribute('r','1.15');
          c.setAttribute('fill', o ? o.fill : '#FFC72C');
          c.setAttribute('stroke', o ? o.stroke : '#C98A0E');
          c.setAttribute('stroke-width','.5');
          g.appendChild(c);
        });
      }
      g0.appendChild(g);
    });
  }
  el.appendChild(svg);
};

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-candle-mount]').forEach(function(el){
    window.SL_mountCandle(el, window.SL_motifFor(el), el.dataset.candleColour);
  });
  const trioTpl = document.getElementById('trio-template');
  if(trioTpl){
    document.querySelectorAll('[data-trio]').forEach(function(el){
      const svg = trioTpl.content.cloneNode(true).querySelector('svg').cloneNode(true);
      svg.setAttribute('preserveAspectRatio','xMidYMid meet');
      svg.style.width='100%'; svg.style.height='100%'; svg.style.display='block';
      el.appendChild(svg);
    });
  }
});

window.replayHero = function(){
  const trio = document.querySelector('.hero-trio .trio-anim');
  if(!trio) return;
  trio.parentNode.replaceChild(trio.cloneNode(true), trio);
};
